<template>
    <div class="scc-registration-check">
        <div class="row row-space">
            <div class="col col-2 scc-state-image-container">
                <h1>Gelukt</h1>
            </div>
            <div class="col col-2 align-center">
                <div class="scc-registration-check-text-container">
                    <template v-if="loading">
                        <h1>Jouw aanmelding wordt gecontroleerd</h1>
                        <p>Controleren...</p>
                    </template>
                    <template v-else-if="error">
                        <h1>Er is iets fout gegaan</h1>
                        <p>Jouw aanmelding kon niet worden gevonden</p>
                    </template>
                    <template v-else-if="order">
                        <template v-if="order.status === 'cancelled'">
                            <h1>Aanmelding mislukt</h1>
                            <h3>Er is iets fout gegeaan met je aanmelding</h3>
                            <p>Probeer het a.u.b. opnieuw</p>
                        </template>

                        <template v-else-if="order.status === 'paid'">
                            <h1>Aanmelding succesvol</h1>
                            <h3>Je aanmelding is gelukt</h3>
                            <p>Als dit een loterij is, zijn je loten verstuurd naar het opgegeven e-mailadres</p>
                            <h5>Veel geluk!</h5>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'RegistrationCheck',
    components: {},
    data() {
        return {
            loading: true,
            error: false,
            order: null,
            retries: 0,
            maxRetries: 10,
            timeoutId: null,
        };
    },
    computed: {
        page() {
            return this.$store.getters.page('bedankt');
        },
        components() {
            return this.page && this.page.components;
        },
        orderId() {
            return this.$route.query.order_id;
        },
        imageName() {
            if (this.order) {
                switch (this.order.status) {
                    case 'paid':
                        return 'success';
                    case 'cancelled':
                        return 'sad_face';
                }
            } else if (this.loading) return 'loading';
            return 'sad_face';
        },
    },
    created() {
        if (!this.orderId) {
            this.loading = false;
            this.error = true;
        }
        if (this.orderId) {
            this.getOrder();
        }
    },
    beforeDestroy() {
        clearTimeout(this.timeoutId);
    },
    methods: {
        getOrder() {
            axios({
                url: process.env.VUE_APP_ENDPOINT,
                method: 'post',
                headers: {
                    Authorization: 'Bearer ' + process.env.VUE_APP_TOKEN,
                },
                data: {
                    query: `
                        query order($orderId: ID!) {
                            order(orderId: $orderId) {
                                id
                                status
                                player {
                                    firstName
                                    email
                                }
                            }
                        }
                    `,
                    variables: {
                        orderId: this.orderId,
                    },
                },
            })
                .then(res => {
                    let order = res.data.data.order;
                    this.order = order;

                    if (order && order.status === 'pending') {
                        this.retry(this.getOrder);
                    }

                    if (order === null) this.error = true;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        retry(fn) {
            this.timeoutId = setTimeout(() => {
                if (this.retries < this.maxRetries) {
                    this.retries += 1;
                    fn();
                }
            }, 3000 + this.retries * 1000);
        },
    },
};
</script>
